import React from "react";

const StepsDisplay = ({ progressWidth, step }) => {
  return (
    <div className="d-flex justify-content-end">
      <div className="steps_container">
        <div className="progress_line">
          <div
            style={{ width: progressWidth }}
            className="progress_line_inner"
          ></div>
        </div>
        <p className="text-center">Step {step} - 3</p>
      </div>
    </div>
  );
};

export default StepsDisplay;
